import { memo } from 'react';
import { RenameForm } from '~/components/dialogs/settings/RenameForm';
import { useProjectRename } from '~/lib/hooks/useProjectRename';

interface ProjectNameProps {
  description?: string;
  canRename?: boolean;
}

export const ProjectName = memo(({ description, canRename }: ProjectNameProps) => {
  const { newTitle, errorMessage, updateTitle, isChanged, handleChange } = useProjectRename();

  return (
    <RenameForm
      title="Project name"
      value={newTitle}
      placeholder="Enter project name"
      handleChange={handleChange}
      handleSubmit={updateTitle}
      isDisabled={!description || !isChanged || !canRename}
      validateErrorMessage={errorMessage || undefined}
    />
  );
});

ProjectName.displayName = 'ProjectName';
